import React from "react";

import { IdentityCard } from "./IdentityCard";

export const ActiveIdentityCard = ({ data }) => <IdentityCard data={data} idPrefix="activeIdentity" />;
